import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _ceec5074 = () => interopDefault(import('../pages/guide/index.vue' /* webpackChunkName: "pages/guide/index" */))
const _4f301db5 = () => interopDefault(import('../pages/integralRules/index.vue' /* webpackChunkName: "pages/integralRules/index" */))
const _7f22500a = () => interopDefault(import('../pages/integralStatistics/index.vue' /* webpackChunkName: "pages/integralStatistics/index" */))
const _077d10f6 = () => interopDefault(import('../pages/internetRegulationRules/index.vue' /* webpackChunkName: "pages/internetRegulationRules/index" */))
const _3b58d1a0 = () => interopDefault(import('../pages/mall/index.vue' /* webpackChunkName: "pages/mall/index" */))
const _a71c1c06 = () => interopDefault(import('../pages/operateActivity/index.vue' /* webpackChunkName: "pages/operateActivity/index" */))
const _02c03ad2 = () => interopDefault(import('../pages/partner/index.vue' /* webpackChunkName: "pages/partner/index" */))
const _367980db = () => interopDefault(import('../pages/preHeating/index.vue' /* webpackChunkName: "pages/preHeating/index" */))
const _0727a8a3 = () => interopDefault(import('../pages/preSecrecy/index.vue' /* webpackChunkName: "pages/preSecrecy/index" */))
const _30ddf657 = () => interopDefault(import('../pages/rewardDescription/index.vue' /* webpackChunkName: "pages/rewardDescription/index" */))
const _321d2c6c = () => interopDefault(import('../pages/taskhall/index.vue' /* webpackChunkName: "pages/taskhall/index" */))
const _84c38550 = () => interopDefault(import('../pages/test-fetch-api/index.vue' /* webpackChunkName: "pages/test-fetch-api/index" */))
const _5224079c = () => interopDefault(import('../pages/typeDetails/index.vue' /* webpackChunkName: "pages/typeDetails/index" */))
const _19b26dba = () => interopDefault(import('../pages/user-info/index.vue' /* webpackChunkName: "pages/user-info/index" */))
const _357de01c = () => interopDefault(import('../pages/wechat/index.vue' /* webpackChunkName: "pages/wechat/index" */))
const _3893bcd8 = () => interopDefault(import('../pages/headlineCollege/article/index.vue' /* webpackChunkName: "pages/headlineCollege/article/index" */))
const _453e8817 = () => interopDefault(import('../pages/headlineCollege/doctor/index.vue' /* webpackChunkName: "pages/headlineCollege/doctor/index" */))
const _67f930e1 = () => interopDefault(import('../pages/integration/add-bank-card.vue' /* webpackChunkName: "pages/integration/add-bank-card" */))
const _531354b0 = () => interopDefault(import('../pages/integration/integration-cash.vue' /* webpackChunkName: "pages/integration/integration-cash" */))
const _7a82ad8e = () => interopDefault(import('../pages/integration/integration-detail.vue' /* webpackChunkName: "pages/integration/integration-detail" */))
const _5561a3d7 = () => interopDefault(import('../pages/integration/my-integration.vue' /* webpackChunkName: "pages/integration/my-integration" */))
const _54cc15c8 = () => interopDefault(import('../pages/integration/reward-details.vue' /* webpackChunkName: "pages/integration/reward-details" */))
const _5c62c416 = () => interopDefault(import('../pages/mall/add-address.vue' /* webpackChunkName: "pages/mall/add-address" */))
const _4da75562 = () => interopDefault(import('../pages/mall/confirm-order.vue' /* webpackChunkName: "pages/mall/confirm-order" */))
const _06f5ec09 = () => interopDefault(import('../pages/mall/exchange-record.vue' /* webpackChunkName: "pages/mall/exchange-record" */))
const _53612c2f = () => interopDefault(import('../pages/mall/good-detail.vue' /* webpackChunkName: "pages/mall/good-detail" */))
const _004a3c32 = () => interopDefault(import('../pages/mall/list-address.vue' /* webpackChunkName: "pages/mall/list-address" */))
const _7ed5e0be = () => interopDefault(import('../pages/mall/order-trancking.vue' /* webpackChunkName: "pages/mall/order-trancking" */))
const _dc39a3a8 = () => interopDefault(import('../pages/mall/pay-success.vue' /* webpackChunkName: "pages/mall/pay-success" */))
const _62c0550b = () => interopDefault(import('../pages/mall/transformData.js' /* webpackChunkName: "pages/mall/transformData" */))
const _3c0c44be = () => interopDefault(import('../pages/operateActivity/rule.vue' /* webpackChunkName: "pages/operateActivity/rule" */))
const _1a00828a = () => interopDefault(import('../pages/partner/cashout.vue' /* webpackChunkName: "pages/partner/cashout" */))
const _24cba1fe = () => interopDefault(import('../pages/partner/detail.vue' /* webpackChunkName: "pages/partner/detail" */))
const _5778cb94 = () => interopDefault(import('../pages/partner/history.vue' /* webpackChunkName: "pages/partner/history" */))
const _5550b14f = () => interopDefault(import('../pages/partner/index1.vue' /* webpackChunkName: "pages/partner/index1" */))
const _2ee3bbd9 = () => interopDefault(import('../pages/partner/plan.vue' /* webpackChunkName: "pages/partner/plan" */))
const _75c4cb3a = () => interopDefault(import('../pages/partner/receive.vue' /* webpackChunkName: "pages/partner/receive" */))
const _572c8301 = () => interopDefault(import('../pages/partner/record.vue' /* webpackChunkName: "pages/partner/record" */))
const _123650fa = () => interopDefault(import('../pages/partner/success.vue' /* webpackChunkName: "pages/partner/success" */))
const _3dd6d37f = () => interopDefault(import('../pages/patient/display.vue' /* webpackChunkName: "pages/patient/display" */))
const _7870e79e = () => interopDefault(import('../pages/patient/kw-subject.vue' /* webpackChunkName: "pages/patient/kw-subject" */))
const _fc0b61c0 = () => interopDefault(import('../pages/posters/jiezhenjiqiao.vue' /* webpackChunkName: "pages/posters/jiezhenjiqiao" */))
const _0ab3286e = () => interopDefault(import('../pages/posters/liuliangfuchi.vue' /* webpackChunkName: "pages/posters/liuliangfuchi" */))
const _7d1743ae = () => interopDefault(import('../pages/prescription/epidemic-prevention.vue' /* webpackChunkName: "pages/prescription/epidemic-prevention" */))
const _49282560 = () => interopDefault(import('../pages/preSecrecy/manaRegulation.vue' /* webpackChunkName: "pages/preSecrecy/manaRegulation" */))
const _012bede2 = () => interopDefault(import('../pages/qa/communityRule.vue' /* webpackChunkName: "pages/qa/communityRule" */))
const _049170a3 = () => interopDefault(import('../pages/qa/daily.vue' /* webpackChunkName: "pages/qa/daily" */))
const _4d346690 = () => interopDefault(import('../pages/qa/insuranceClauses.vue' /* webpackChunkName: "pages/qa/insuranceClauses" */))
const _04b9c71e = () => interopDefault(import('../pages/qa/national-standard-guide.vue' /* webpackChunkName: "pages/qa/national-standard-guide" */))
const _8a6e25ce = () => interopDefault(import('../pages/qa/newhand.vue' /* webpackChunkName: "pages/qa/newhand" */))
const _572bc562 = () => interopDefault(import('../pages/qa/personalInformationProtection.vue' /* webpackChunkName: "pages/qa/personalInformationProtection" */))
const _1831aeac = () => interopDefault(import('../pages/qa/profit.vue' /* webpackChunkName: "pages/qa/profit" */))
const _406880e2 = () => interopDefault(import('../pages/qa/rule.vue' /* webpackChunkName: "pages/qa/rule" */))
const _2caa0be6 = () => interopDefault(import('../pages/qa/userule.vue' /* webpackChunkName: "pages/qa/userule" */))
const _4faf0e13 = () => interopDefault(import('../pages/serviceReviews/review-list.vue' /* webpackChunkName: "pages/serviceReviews/review-list" */))
const _3e2e0b56 = () => interopDefault(import('../pages/taskhall/finance_details.vue' /* webpackChunkName: "pages/taskhall/finance_details" */))
const _b6b20ed2 = () => interopDefault(import('../pages/taskhall/latest-events.vue' /* webpackChunkName: "pages/taskhall/latest-events" */))
const _97499908 = () => interopDefault(import('../pages/taskhall/level.vue' /* webpackChunkName: "pages/taskhall/level" */))
const _1a044199 = () => interopDefault(import('../pages/taskhall/level-swiper.vue' /* webpackChunkName: "pages/taskhall/level-swiper" */))
const _5ab0baf0 = () => interopDefault(import('../pages/taskhall/my_badge.vue' /* webpackChunkName: "pages/taskhall/my_badge" */))
const _1937dac0 = () => interopDefault(import('../pages/taskhall/partner.vue' /* webpackChunkName: "pages/taskhall/partner" */))
const _6db01cc4 = () => interopDefault(import('../pages/taskhall/share_banner.vue' /* webpackChunkName: "pages/taskhall/share_banner" */))
const _feeeedf4 = () => interopDefault(import('../pages/taskhall/sign-in-strategy/index.vue' /* webpackChunkName: "pages/taskhall/sign-in-strategy/index" */))
const _3a3ef867 = () => interopDefault(import('../pages/taskhall/task-explain.vue' /* webpackChunkName: "pages/taskhall/task-explain" */))
const _2c38a6e8 = () => interopDefault(import('../pages/taskhall/taskHall2.vue' /* webpackChunkName: "pages/taskhall/taskHall2" */))
const _1681d2b8 = () => interopDefault(import('../pages/taskhall/total-task-progress.vue' /* webpackChunkName: "pages/taskhall/total-task-progress" */))
const _1af37352 = () => interopDefault(import('../pages/user-info/doctor-Insurance/index.vue' /* webpackChunkName: "pages/user-info/doctor-Insurance/index" */))
const _cb67689c = () => interopDefault(import('../pages/user-info/electronic-signature/index.vue' /* webpackChunkName: "pages/user-info/electronic-signature/index" */))
const _2367743c = () => interopDefault(import('../pages/wechat/display.vue' /* webpackChunkName: "pages/wechat/display" */))
const _1242f3ac = () => interopDefault(import('../pages/wechat/push.vue' /* webpackChunkName: "pages/wechat/push" */))
const _77e97358 = () => interopDefault(import('../pages/wechat/reason.vue' /* webpackChunkName: "pages/wechat/reason" */))
const _66ab1da2 = () => interopDefault(import('../pages/wechat/request.vue' /* webpackChunkName: "pages/wechat/request" */))
const _3c84e4a3 = () => interopDefault(import('../pages/wechat/success.vue' /* webpackChunkName: "pages/wechat/success" */))
const _325fd492 = () => interopDefault(import('../pages/headlineCollege/components/KwButton.vue' /* webpackChunkName: "pages/headlineCollege/components/KwButton" */))
const _28fdfb58 = () => interopDefault(import('../pages/headlineCollege/components/KwTitleCard.vue' /* webpackChunkName: "pages/headlineCollege/components/KwTitleCard" */))
const _db40f56a = () => interopDefault(import('../pages/headlineCollege/components/KwVideoHead.vue' /* webpackChunkName: "pages/headlineCollege/components/KwVideoHead" */))
const _686d69e4 = () => interopDefault(import('../pages/headlineCollege/components/tipBox.vue' /* webpackChunkName: "pages/headlineCollege/components/tipBox" */))
const _d3ee2cf4 = () => interopDefault(import('../pages/headlineCollege/components/tipModal.vue' /* webpackChunkName: "pages/headlineCollege/components/tipModal" */))
const _6e2c1578 = () => interopDefault(import('../pages/headlineCollege/doctor/join-application.vue' /* webpackChunkName: "pages/headlineCollege/doctor/join-application" */))
const _d9f630f0 = () => interopDefault(import('../pages/headlineCollege/doctor/success.vue' /* webpackChunkName: "pages/headlineCollege/doctor/success" */))
const _720b6c2b = () => interopDefault(import('../pages/integralStatistics/components/statistics-item.vue' /* webpackChunkName: "pages/integralStatistics/components/statistics-item" */))
const _0a19e924 = () => interopDefault(import('../pages/mall/components/AddresList.vue' /* webpackChunkName: "pages/mall/components/AddresList" */))
const _1d400cac = () => interopDefault(import('../pages/mall/components/Cart/index.vue' /* webpackChunkName: "pages/mall/components/Cart/index" */))
const _fe5f0748 = () => interopDefault(import('../pages/mall/components/GoodOverlay.vue' /* webpackChunkName: "pages/mall/components/GoodOverlay" */))
const _4c81ff46 = () => interopDefault(import('../pages/mall/components/GoodsList.vue' /* webpackChunkName: "pages/mall/components/GoodsList" */))
const _33b3daf6 = () => interopDefault(import('../pages/mall/components/KwButton.vue' /* webpackChunkName: "pages/mall/components/KwButton" */))
const _1473db4c = () => interopDefault(import('../pages/mall/components/Merchandise.vue' /* webpackChunkName: "pages/mall/components/Merchandise" */))
const _5f1d7855 = () => interopDefault(import('../pages/mall/components/OrderList.vue' /* webpackChunkName: "pages/mall/components/OrderList" */))
const _40ab49ea = () => interopDefault(import('../pages/mall/components/RecordItem.vue' /* webpackChunkName: "pages/mall/components/RecordItem" */))
const _1f8bd585 = () => interopDefault(import('../pages/mall/components/ShoppingCartAnimation.vue' /* webpackChunkName: "pages/mall/components/ShoppingCartAnimation" */))
const _3b7c2994 = () => interopDefault(import('../pages/mall/components/UnitStepper.vue' /* webpackChunkName: "pages/mall/components/UnitStepper" */))
const _4cd8244a = () => interopDefault(import('../pages/operateActivity/components/completeText.vue' /* webpackChunkName: "pages/operateActivity/components/completeText" */))
const _3ddfa732 = () => interopDefault(import('../pages/operateActivity/components/floatBall.vue' /* webpackChunkName: "pages/operateActivity/components/floatBall" */))
const _7f65f8a2 = () => interopDefault(import('../pages/partner/components/weelyReport.vue' /* webpackChunkName: "pages/partner/components/weelyReport" */))
const _c620dd2e = () => interopDefault(import('../pages/taskhall/components/activity-banner.vue' /* webpackChunkName: "pages/taskhall/components/activity-banner" */))
const _b19441ca = () => interopDefault(import('../pages/taskhall/components/activity-list.vue' /* webpackChunkName: "pages/taskhall/components/activity-list" */))
const _1a79c095 = () => interopDefault(import('../pages/taskhall/components/beanProgressBar.vue' /* webpackChunkName: "pages/taskhall/components/beanProgressBar" */))
const _1cdaf5ce = () => interopDefault(import('../pages/taskhall/components/kw-echart.vue' /* webpackChunkName: "pages/taskhall/components/kw-echart" */))
const _035d9c65 = () => interopDefault(import('../pages/taskhall/components/qd-module.vue' /* webpackChunkName: "pages/taskhall/components/qd-module" */))
const _8a2b5318 = () => interopDefault(import('../pages/taskhall/components/sign-in.vue' /* webpackChunkName: "pages/taskhall/components/sign-in" */))
const _132194da = () => interopDefault(import('../pages/taskhall/components/task-item.vue' /* webpackChunkName: "pages/taskhall/components/task-item" */))
const _9c3bfa92 = () => interopDefault(import('../pages/taskhall/components/task-item-line.vue' /* webpackChunkName: "pages/taskhall/components/task-item-line" */))
const _2211dbb8 = () => interopDefault(import('../pages/taskhall/components/task2-item.vue' /* webpackChunkName: "pages/taskhall/components/task2-item" */))
const _18412aaa = () => interopDefault(import('../pages/typeDetails/compoents/type-details-item.vue' /* webpackChunkName: "pages/typeDetails/compoents/type-details-item" */))
const _933008a4 = () => interopDefault(import('../pages/user-info/electronic-signature/ca.vue' /* webpackChunkName: "pages/user-info/electronic-signature/ca" */))
const _387caa96 = () => interopDefault(import('../pages/user-info/doctor-Insurance/compoents/upload/index.vue' /* webpackChunkName: "pages/user-info/doctor-Insurance/compoents/upload/index" */))
const _900b5b4e = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/doctor2/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/guide",
    component: _ceec5074,
    name: "guide"
  }, {
    path: "/integralRules",
    component: _4f301db5,
    name: "integralRules"
  }, {
    path: "/integralStatistics",
    component: _7f22500a,
    name: "integralStatistics"
  }, {
    path: "/internetRegulationRules",
    component: _077d10f6,
    name: "internetRegulationRules"
  }, {
    path: "/mall",
    component: _3b58d1a0,
    name: "mall"
  }, {
    path: "/operateActivity",
    component: _a71c1c06,
    name: "operateActivity"
  }, {
    path: "/partner",
    component: _02c03ad2,
    name: "partner"
  }, {
    path: "/preHeating",
    component: _367980db,
    name: "preHeating"
  }, {
    path: "/preSecrecy",
    component: _0727a8a3,
    name: "preSecrecy"
  }, {
    path: "/rewardDescription",
    component: _30ddf657,
    name: "rewardDescription"
  }, {
    path: "/taskhall",
    component: _321d2c6c,
    name: "taskhall"
  }, {
    path: "/test-fetch-api",
    component: _84c38550,
    name: "test-fetch-api"
  }, {
    path: "/typeDetails",
    component: _5224079c,
    name: "typeDetails"
  }, {
    path: "/user-info",
    component: _19b26dba,
    name: "user-info"
  }, {
    path: "/wechat",
    component: _357de01c,
    name: "wechat"
  }, {
    path: "/headlineCollege/article",
    component: _3893bcd8,
    name: "headlineCollege-article"
  }, {
    path: "/headlineCollege/doctor",
    component: _453e8817,
    name: "headlineCollege-doctor"
  }, {
    path: "/integration/add-bank-card",
    component: _67f930e1,
    name: "integration-add-bank-card"
  }, {
    path: "/integration/integration-cash",
    component: _531354b0,
    name: "integration-integration-cash"
  }, {
    path: "/integration/integration-detail",
    component: _7a82ad8e,
    name: "integration-integration-detail"
  }, {
    path: "/integration/my-integration",
    component: _5561a3d7,
    name: "integration-my-integration"
  }, {
    path: "/integration/reward-details",
    component: _54cc15c8,
    name: "integration-reward-details"
  }, {
    path: "/mall/add-address",
    component: _5c62c416,
    name: "mall-add-address"
  }, {
    path: "/mall/confirm-order",
    component: _4da75562,
    name: "mall-confirm-order"
  }, {
    path: "/mall/exchange-record",
    component: _06f5ec09,
    name: "mall-exchange-record"
  }, {
    path: "/mall/good-detail",
    component: _53612c2f,
    name: "mall-good-detail"
  }, {
    path: "/mall/list-address",
    component: _004a3c32,
    name: "mall-list-address"
  }, {
    path: "/mall/order-trancking",
    component: _7ed5e0be,
    name: "mall-order-trancking"
  }, {
    path: "/mall/pay-success",
    component: _dc39a3a8,
    name: "mall-pay-success"
  }, {
    path: "/mall/transformData",
    component: _62c0550b,
    name: "mall-transformData"
  }, {
    path: "/operateActivity/rule",
    component: _3c0c44be,
    name: "operateActivity-rule"
  }, {
    path: "/partner/cashout",
    component: _1a00828a,
    name: "partner-cashout"
  }, {
    path: "/partner/detail",
    component: _24cba1fe,
    name: "partner-detail"
  }, {
    path: "/partner/history",
    component: _5778cb94,
    name: "partner-history"
  }, {
    path: "/partner/index1",
    component: _5550b14f,
    name: "partner-index1"
  }, {
    path: "/partner/plan",
    component: _2ee3bbd9,
    name: "partner-plan"
  }, {
    path: "/partner/receive",
    component: _75c4cb3a,
    name: "partner-receive"
  }, {
    path: "/partner/record",
    component: _572c8301,
    name: "partner-record"
  }, {
    path: "/partner/success",
    component: _123650fa,
    name: "partner-success"
  }, {
    path: "/patient/display",
    component: _3dd6d37f,
    name: "patient-display"
  }, {
    path: "/patient/kw-subject",
    component: _7870e79e,
    name: "patient-kw-subject"
  }, {
    path: "/posters/jiezhenjiqiao",
    component: _fc0b61c0,
    name: "posters-jiezhenjiqiao"
  }, {
    path: "/posters/liuliangfuchi",
    component: _0ab3286e,
    name: "posters-liuliangfuchi"
  }, {
    path: "/prescription/epidemic-prevention",
    component: _7d1743ae,
    name: "prescription-epidemic-prevention"
  }, {
    path: "/preSecrecy/manaRegulation",
    component: _49282560,
    name: "preSecrecy-manaRegulation"
  }, {
    path: "/qa/communityRule",
    component: _012bede2,
    name: "qa-communityRule"
  }, {
    path: "/qa/daily",
    component: _049170a3,
    name: "qa-daily"
  }, {
    path: "/qa/insuranceClauses",
    component: _4d346690,
    name: "qa-insuranceClauses"
  }, {
    path: "/qa/national-standard-guide",
    component: _04b9c71e,
    name: "qa-national-standard-guide"
  }, {
    path: "/qa/newhand",
    component: _8a6e25ce,
    name: "qa-newhand"
  }, {
    path: "/qa/personalInformationProtection",
    component: _572bc562,
    name: "qa-personalInformationProtection"
  }, {
    path: "/qa/profit",
    component: _1831aeac,
    name: "qa-profit"
  }, {
    path: "/qa/rule",
    component: _406880e2,
    name: "qa-rule"
  }, {
    path: "/qa/userule",
    component: _2caa0be6,
    name: "qa-userule"
  }, {
    path: "/serviceReviews/review-list",
    component: _4faf0e13,
    name: "serviceReviews-review-list"
  }, {
    path: "/taskhall/finance_details",
    component: _3e2e0b56,
    name: "taskhall-finance_details"
  }, {
    path: "/taskhall/latest-events",
    component: _b6b20ed2,
    name: "taskhall-latest-events"
  }, {
    path: "/taskhall/level",
    component: _97499908,
    name: "taskhall-level"
  }, {
    path: "/taskhall/level-swiper",
    component: _1a044199,
    name: "taskhall-level-swiper"
  }, {
    path: "/taskhall/my_badge",
    component: _5ab0baf0,
    name: "taskhall-my_badge"
  }, {
    path: "/taskhall/partner",
    component: _1937dac0,
    name: "taskhall-partner"
  }, {
    path: "/taskhall/share_banner",
    component: _6db01cc4,
    name: "taskhall-share_banner"
  }, {
    path: "/taskhall/sign-in-strategy",
    component: _feeeedf4,
    name: "taskhall-sign-in-strategy"
  }, {
    path: "/taskhall/task-explain",
    component: _3a3ef867,
    name: "taskhall-task-explain"
  }, {
    path: "/taskhall/taskHall2",
    component: _2c38a6e8,
    name: "taskhall-taskHall2"
  }, {
    path: "/taskhall/total-task-progress",
    component: _1681d2b8,
    name: "taskhall-total-task-progress"
  }, {
    path: "/user-info/doctor-Insurance",
    component: _1af37352,
    name: "user-info-doctor-Insurance"
  }, {
    path: "/user-info/electronic-signature",
    component: _cb67689c,
    name: "user-info-electronic-signature"
  }, {
    path: "/wechat/display",
    component: _2367743c,
    name: "wechat-display"
  }, {
    path: "/wechat/push",
    component: _1242f3ac,
    name: "wechat-push"
  }, {
    path: "/wechat/reason",
    component: _77e97358,
    name: "wechat-reason"
  }, {
    path: "/wechat/request",
    component: _66ab1da2,
    name: "wechat-request"
  }, {
    path: "/wechat/success",
    component: _3c84e4a3,
    name: "wechat-success"
  }, {
    path: "/headlineCollege/components/KwButton",
    component: _325fd492,
    name: "headlineCollege-components-KwButton"
  }, {
    path: "/headlineCollege/components/KwTitleCard",
    component: _28fdfb58,
    name: "headlineCollege-components-KwTitleCard"
  }, {
    path: "/headlineCollege/components/KwVideoHead",
    component: _db40f56a,
    name: "headlineCollege-components-KwVideoHead"
  }, {
    path: "/headlineCollege/components/tipBox",
    component: _686d69e4,
    name: "headlineCollege-components-tipBox"
  }, {
    path: "/headlineCollege/components/tipModal",
    component: _d3ee2cf4,
    name: "headlineCollege-components-tipModal"
  }, {
    path: "/headlineCollege/doctor/join-application",
    component: _6e2c1578,
    name: "headlineCollege-doctor-join-application"
  }, {
    path: "/headlineCollege/doctor/success",
    component: _d9f630f0,
    name: "headlineCollege-doctor-success"
  }, {
    path: "/integralStatistics/components/statistics-item",
    component: _720b6c2b,
    name: "integralStatistics-components-statistics-item"
  }, {
    path: "/mall/components/AddresList",
    component: _0a19e924,
    name: "mall-components-AddresList"
  }, {
    path: "/mall/components/Cart",
    component: _1d400cac,
    name: "mall-components-Cart"
  }, {
    path: "/mall/components/GoodOverlay",
    component: _fe5f0748,
    name: "mall-components-GoodOverlay"
  }, {
    path: "/mall/components/GoodsList",
    component: _4c81ff46,
    name: "mall-components-GoodsList"
  }, {
    path: "/mall/components/KwButton",
    component: _33b3daf6,
    name: "mall-components-KwButton"
  }, {
    path: "/mall/components/Merchandise",
    component: _1473db4c,
    name: "mall-components-Merchandise"
  }, {
    path: "/mall/components/OrderList",
    component: _5f1d7855,
    name: "mall-components-OrderList"
  }, {
    path: "/mall/components/RecordItem",
    component: _40ab49ea,
    name: "mall-components-RecordItem"
  }, {
    path: "/mall/components/ShoppingCartAnimation",
    component: _1f8bd585,
    name: "mall-components-ShoppingCartAnimation"
  }, {
    path: "/mall/components/UnitStepper",
    component: _3b7c2994,
    name: "mall-components-UnitStepper"
  }, {
    path: "/operateActivity/components/completeText",
    component: _4cd8244a,
    name: "operateActivity-components-completeText"
  }, {
    path: "/operateActivity/components/floatBall",
    component: _3ddfa732,
    name: "operateActivity-components-floatBall"
  }, {
    path: "/partner/components/weelyReport",
    component: _7f65f8a2,
    name: "partner-components-weelyReport"
  }, {
    path: "/taskhall/components/activity-banner",
    component: _c620dd2e,
    name: "taskhall-components-activity-banner"
  }, {
    path: "/taskhall/components/activity-list",
    component: _b19441ca,
    name: "taskhall-components-activity-list"
  }, {
    path: "/taskhall/components/beanProgressBar",
    component: _1a79c095,
    name: "taskhall-components-beanProgressBar"
  }, {
    path: "/taskhall/components/kw-echart",
    component: _1cdaf5ce,
    name: "taskhall-components-kw-echart"
  }, {
    path: "/taskhall/components/qd-module",
    component: _035d9c65,
    name: "taskhall-components-qd-module"
  }, {
    path: "/taskhall/components/sign-in",
    component: _8a2b5318,
    name: "taskhall-components-sign-in"
  }, {
    path: "/taskhall/components/task-item",
    component: _132194da,
    name: "taskhall-components-task-item"
  }, {
    path: "/taskhall/components/task-item-line",
    component: _9c3bfa92,
    name: "taskhall-components-task-item-line"
  }, {
    path: "/taskhall/components/task2-item",
    component: _2211dbb8,
    name: "taskhall-components-task2-item"
  }, {
    path: "/typeDetails/compoents/type-details-item",
    component: _18412aaa,
    name: "typeDetails-compoents-type-details-item"
  }, {
    path: "/user-info/electronic-signature/ca",
    component: _933008a4,
    name: "user-info-electronic-signature-ca"
  }, {
    path: "/user-info/doctor-Insurance/compoents/upload",
    component: _387caa96,
    name: "user-info-doctor-Insurance-compoents-upload"
  }, {
    path: "/",
    component: _900b5b4e,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
